import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { agentgatewayKeysApiRef, AgentgatewayKeysClient } from './api';

export const agentgatewayKeysPlugin = createPlugin({
  id: 'agentgateway-keys',
  apis: [
    createApiFactory({
      api: agentgatewayKeysApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new AgentgatewayKeysClient({ discoveryApi, identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AgentgatewayKeysPage = agentgatewayKeysPlugin.provide(
  createRoutableExtension({
    name: 'AgentgatewayKeysPage',
    component: () =>
      import('./components/AgentgatewayKeysPage').then(m => m.AgentgatewayKeysPage),
    mountPoint: rootRouteRef,
  }),
);
